export const shortAboutData = {
	title: 'Коротко о компании',
	description: [
		'Credit.Club — платформа цифровых решений для кредитования и инвестирования. Миссия компании — делать кредиты доступными, развивая технологии для всех участников рынка. Команда работает с 2012 года.',
		'Credit.Club не является агрегатором или кредитным брокером, выдаёт деньги клиентам без посредников.',
	],
	sections: [
		{
			title: 'Кредиты',
			content:
				'Заёмщики могут получить крупную сумму под залог квартиры без посещения офиса банка по всей России. В компании действует множество кредитных программ, которые позволяют помогать клиентам в разных жизненных ситуациях.',
		},
		{
			title: 'Инвестиции',
			content:
				'Есть и продукты для сберегателей: инвесторы могут приумножить свои накопления используя «Сбережения». По принципу работы они похожи на банковский вклад: процент дохода и срок зафиксированы в договоре, их можно пополнять и закрывать досрочно.',
		},
		{
			title: 'Технологии',
			content:
				'Третье направление — разработка технологий и автоматизация процессов для финансовых организаций. Опыт команды могут применять и другие кредиторы, подключившись к платформе. Им открывается доступ к сервисам, приложениям и экспертизе Credit.Club.',
		},
		{
			title: 'Образование',
			content:
				'Кроме этого, Credit.Club является стратегическим партнёром АФГ «Процент» и помогает развивать финансовую грамотность в стране. На базе ассоциации создаются спецпроекты, записываются полезные видео и пишутся статьи совместно с экспертами в финансовой тематике.',
		},
	],
}
